import { render, staticRenderFns } from "./addfirm.vue?vue&type=template&id=58ddd2d5&scoped=true"
import script from "./addfirm.vue?vue&type=script&lang=js"
export * from "./addfirm.vue?vue&type=script&lang=js"
import style0 from "./addfirm.vue?vue&type=style&index=0&id=58ddd2d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ddd2d5",
  null
  
)

export default component.exports